function serializeLiveCheckTripParams(opts) {
    const {
        tripId,
        seats,
        wheelchairs,
        selectedFare,
    } = opts;

    if (selectedFare) {
        return [tripId, seats, wheelchairs, selectedFare].join('-');
    }

    return [tripId, seats, wheelchairs].join('-');
}

function serializeLiveCheckCachedTripParams(opts) {
    const {
        tripId,
        token,
    } = opts;

    return [tripId, token].join('-');
}

function buildLiveLinkBody(opts) {
    const {
        allTripIds,
        autoEnablePromos,
        autofill = false,
        locale = '',
        tripId,
        seats = 1,
        wheelchairs = 0,
        currency,
        exchangeRate,
        itineraryId,
        affiliateId,
        trackingId,
        selectedFare,
        fareVersion,
    } = opts;
    const [
        language,
        location,
    ] = locale.split('-');

    if (!tripId) {
        throw new Error('tripId must be provided');
    } else if (!locale || !language || !location) {
        throw new Error('locale must be a <language>-<country> pair');
    } else if (!currency || !exchangeRate) {
        throw new Error('currency and exchange rate must be provided');
    }

    return {
        auto_enable_promos: autoEnablePromos,
        autofill: `${!!autofill}`, // string containing a boolean value :-|
        country_code: location,
        currency,
        exchange_rate: exchangeRate,
        httpStatusOk: 1,
        itinerary_id: itineraryId,
        itinerary_trip_ids: allTripIds,
        lang: language,
        link_type: 'desktop',
        seats,
        trip_id: tripId,
        wheelchairs,
        affiliate_id: affiliateId,
        affiliate_tracking_id: trackingId,
        selected_fare: selectedFare,
        fare_version: fareVersion,
    };
}

export {
    buildLiveLinkBody,
    serializeLiveCheckCachedTripParams,
    serializeLiveCheckTripParams,
};
